<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
  export default {
    name: 'app',
    watch: {
    	'$route' (to, from) {
        document.title = to.meta.title
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/App.vue